/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactUs } from '../models/ContactUs';
import type { ContactUsRequest } from '../models/ContactUsRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ContactusService {

    /**
     * @returns ContactUs
     * @throws ApiError
     */
    public static contactusCreate({
        requestBody,
    }: {
        requestBody: ContactUsRequest,
    }): CancelablePromise<ContactUs> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v3/contactus/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
